import { Badge, DefaultTooltip } from 'twyne-new.ui'

import PasteIntoSelect from './PasteIntoSelect'

export const HELPERS = ['md5', 'lower', 'upper', 'capitalize', 'url_param_value']

const EXAMPLES = [
  'ex: {md5(first-name="{firstName}"&last-name="{lastName}")}',
  'ex: {md5(lower(email={email}))}',
]

export default function PageHelpers({ paste }) {
  const { selected, insert, insertLabel } = paste

  return <div className='flex flex-col gap-4'>
    <p className='twy-text-base'>
      Mergetag helpers make it possible to transform content as needed. The helper must be called between braces and
      the value to be processed must be added between parentheses. It is possible to nest helper calls:
    </p>
    <div className='border twy-border-base rounded-xs p-4 flex flex-col gap-2'>
      {EXAMPLES.map(example => <span key={example} className='font-mono text-sm twy-text-base-accent'>
        {example}
      </span>)}
    </div>
    <PasteIntoSelect className='w-full mt-4' selected={selected} />
    <div className='flex flex-wrap gap-2'>
      {HELPERS.map(helper => <DefaultTooltip
        key={helper}
        content={insertLabel(`{${helper}()}`)}
        triggerProps={{ asChild: true }}
      >
        <Badge
          variant='outline'
          color='accent'
          size='lg'
          className='font-mono cursor-pointer transition-colors hover:twy-subtle-accent'
          asChild
        >
          <button type='button' aria-disabled={!selected} onClick={() => insert(`{${helper}()}`)}>
            {`{${helper}()}`}
          </button>
        </Badge>
      </DefaultTooltip>)}
    </div>
  </div>
}
